import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Router } from "@angular/router";
// services
import { ErrorHandler } from "../../../services/error-handler.service";
import { LoginService } from "../../../services/login.service";
// models
import { AppState } from "../../../../booking/models/app-state.interface";
import { ModalData } from "../../../models/modal.interface";
// ngrx store
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";

@Component({
  selector: 'app-modal-add-password',
  templateUrl: './modal-add-password.component.html',
  styleUrls: ['./modal-add-password.component.scss']
})
export class ModalAddPasswordComponent implements OnInit, OnDestroy {
  @Input() modalData: ModalData;

  @Input() appCopy;
  @Input() selectedLanguage;

  private _passwordSubscription: Subscription;
  private _setPasswordSubscription: Subscription;

  public modalList: Array<any> = [];
  public showLoader: Boolean = false;
  public passwordMatch: Boolean = true;
  public passwordValues: any = {
    password1: "",
    password2: "",
  };
  showPassword: { [key: string]: boolean } = {
    password: false,
    confirmPassword: false
  };

  constructor(
    private _errorService: ErrorHandler,
    private _loginService: LoginService,
    public appStore: Store<AppState>

  ) { }

  ngOnInit() {

    // Step 3 save user details
    this._passwordSubscription = this._loginService.userSubject$.subscribe(
      (user) => {
        if (user.error) {
          this.showLoader = false;
          this._errorService.handleError(user.error);
        }

        const data = {
          text: 'Password updated successfully!',
          type: 'info',
          icon: 'alert',
          sticky: false
        };

        this._errorService.handleCustomInfo(data);

        this._loginService.userHasPassword();
        this._errorService.modalItem$.next("remove");

      },
      (err) => console.log(err)
    );

    this._setPasswordSubscription = this._loginService.setPasswordSubject$.subscribe((res) => {
      if (res.error) {
        this.showLoader = false;
      }
    });

  }

  togglePasswordVisibility(field: string): void {
    this.showPassword[field] = !this.showPassword[field];
  }

  passwordsEqual(skipOnEmpty = false) {
    let isMatch;

    if (this.passwordValues.password2 === "" && skipOnEmpty) {
      isMatch = true;
      this.passwordMatch = isMatch;
      return;
    }

    if (this.passwordValues.password1 === this.passwordValues.password2) {
      isMatch = true;
    } else {
      isMatch = false;
    }

    this.passwordMatch = isMatch;
  }

  close(event) {
    this._errorService.modalItem$.next("remove");
  }

  handleSubmit(value, e) {
    e.preventDefault();


    if (this.passwordMatch) {
      this.showLoader = true;

      this.passwordValues = {
        password1: value.Password,
        password2: value.PasswordVerify,
      };

      this.postPasswordChange();
    }
  }


  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  postPasswordChange() {
    const password = btoa(this.passwordValues.password1);
    const userToken = this.getState(this.appStore).userReducer.userDetails.userToken;

    // works on server
    this._loginService.setPassword(
      this.modalData.userEmail,
      password,
      'mmb',
      null,
      userToken
    );
  }

  ngOnDestroy() {
    this._passwordSubscription.unsubscribe();
    if (this._setPasswordSubscription) {
      this._setPasswordSubscription.unsubscribe();
    }
  }

}
